import { useNavigate } from 'react-router-dom';
import { colors } from '../theme';

/**
 * Standard page header with an optional back button and a right slot -
 * the web counterpart of the app's <Header />.
 */
const PageHeader = ({ title, subtitle, back = true, onBack, right, style }) => {
  const navigate = useNavigate();

  return (
    <div className="row" style={{ marginBottom: 16, gap: 12, alignItems: 'flex-start', ...style }}>
      {back ? (
        <button
          type="button"
          className="press"
          onClick={onBack || (() => navigate(-1))}
          aria-label="Go back"
          style={{
            width: 34, height: 34, borderRadius: 12, flex: '0 0 auto',
            background: '#fff', border: `1px solid ${colors.line}`,
            fontSize: 17, lineHeight: 1, color: colors.ink,
          }}
        >
          ‹
        </button>
      ) : null}
      <div className="grow">
        <h2 className="h2 clamp-1">{title}</h2>
        {subtitle ? <div className="t-small" style={{ marginTop: 2 }}>{subtitle}</div> : null}
      </div>
      {right}
    </div>
  );
};

export default PageHeader;
